module.exports = __webpack_public_path__ + "b553da506077488bc65289e10841d527.woff";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-light-italic.woff
// module id = 1536
// module chunks = 0